import { WindowEditRegular } from "@fluentui/react-icons";
import { Button, Tooltip } from "@fluentui/react-components";

import styles from "./ClearChatButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const ClearChatButton = ({ className, disabled, onClick }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Tooltip content="Start New Chat" relationship="description">
                <Button icon={<WindowEditRegular />} onClick={onClick}></Button>
            </Tooltip>
        </div>
    );
};
